import React, { useState } from 'react';
import '../App.css';
import { FaVolumeUp, FaVolumeDown } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { useBluetooth } from '../BluetoothContext'; 
import { Modal } from 'react-bootstrap'; 

const Configvol: React.FC = () => {
  const [volumeUp, setVolumeUp] = useState<string>('');
  const [volumeDown, setVolumeDown] = useState<string>('');
  const [popupVisible, setPopupVisible] = useState(false);
  const [popup2Visible, setPopup2Visible] = useState(false);
  const [isOverlayVisible, setIsOverlayVisible] = useState(false); 

  const { configureVolume } = useBluetooth(); 

  const handleVolumeUpChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = Math.min(100, Math.max(1, parseInt(event.target.value) || 0));
    setVolumeUp(value.toString());
  };

  const handleVolumeDownChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = Math.min(100, Math.max(1, parseInt(event.target.value) || 0));
    setVolumeDown(value.toString());
  };

  const isSubmitEnabled = volumeUp.trim() !== '' && volumeDown.trim() !== '';

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    try {
      const minVolume = parseInt(volumeDown);
      const maxVolume = parseInt(volumeUp);
      await configureVolume(minVolume, maxVolume); 
      if (minVolume > maxVolume) {
        setPopup2Visible(true);
      } else {
        console.log('Volume configured successfully');
        setPopupVisible(true);
      }
    } catch (error) {
      console.error('Error configuring volume:', error);
    }
    setVolumeUp('');
    setVolumeDown('');
  };

  const navigate = useNavigate();
  const handleReturnHome = () => {
    navigate('/');
  };

  const handleInstructionClick = () => {
    setIsOverlayVisible(!isOverlayVisible);
  };

  return (
    <div className="config-background">
      <h1 className="config-text">Configure Volume</h1>
      <span
        className="info-icon fs-3 ms-3"
        role="img"
        aria-label="info"
        onClick={handleInstructionClick}
        style={{ cursor: 'pointer', color: 'black' }}
      >
        ℹ️ Instructions
      </span>

      <div className="form-card">
        <form onSubmit={handleSubmit} className="config-form">
          <div className="input-group">
            <label htmlFor="volumeUp">
              <FaVolumeUp className="input-icon" />
              Volume Max:
            </label>
            <input
              type="number"
              id="volumeUp"
              name="volumeUp"
              value={volumeUp}
              min={1}
              max={100}
              onChange={handleVolumeUpChange}
              className="input-field"
            />
          </div>

          <div className="input-group">
            <label htmlFor="volumeDown">
              <FaVolumeDown className="input-icon" />
              Volume Min:
            </label>
            <input
              type="number"
              id="volumeDown"
              name="volumeDown"
              value={volumeDown}
              min={1}
              max={100}
              onChange={handleVolumeDownChange}
              className="input-field"
            />
          </div>

          <button
            type="submit"
            disabled={!isSubmitEnabled}
            className={`submit-button ${!isSubmitEnabled ? 'disabled' : ''}`}
          >
            Submit
          </button>
        </form>
      </div>

      {popupVisible && (
        <div className="popup-container">
          <div className="popup-message">Volume Configured Successfully!</div>
          <button className="return-home-button" onClick={handleReturnHome}>
            Return Home
          </button>
        </div>
      )}

      {popup2Visible && (
        <div className="popup-container">
          <div className="popup-message">Your Min Volume is greater than Max Volume</div>
          <button className="enter-again-button" onClick={() => setPopup2Visible(false)}>
            Enter Again
          </button>
        </div>
      )}

      {/* Instruction Overlay Modal */}
      <Modal show={isOverlayVisible} onHide={handleInstructionClick} centered>
        <Modal.Header closeButton>
          <Modal.Title>Instructions</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>This sets the <strong>maximum and minimum volume</strong> your remote can use.</p>
          <ol>
            <li>Enter the <strong>maximum volume</strong> allowed.</li>
            <li>Enter the <strong>minimum volume</strong> allowed.</li>
            <li>Press <strong>Submit</strong> to save.</li>
            <li>Test the volume buttons to confirm the range works correctly.</li>
          </ol>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default Configvol;
